// extracted by mini-css-extract-plugin
module.exports = {"pt-login":"pt-login-f1685f207c1669a4491446e6c047c477","getValidCode":"getValidCode-9344ed82e70c92999558801bca76f4a7"};